import type { StepsProps } from "antd/lib/steps";
import { ComponentPropsWithoutRef } from "react";

import { UseMultistepReturn } from "./useMultistep";
import { Steps } from "../uikit/navigation/Steps/Steps";

type Props = {
    className?: string;
    multistep: UseMultistepReturn;
    isSubmitting?: boolean;
} & ComponentPropsWithoutRef<"nav">;

function MutltistepFormNavigation({ className, multistep, isSubmitting }: Props) {
    const { steps, stepIndex: currentStepIndex, jump } = multistep;

    const antStepsItems: NonNullable<StepsProps["items"]> = steps.map(step => {
        let status: StepsProps["status"] | undefined = undefined;

        if (step.visited && !step.valid) {
            status = "error";
        }

        const itemDisabled = isSubmitting || !step.reachable;
        const stepItem = {
            title: step.label,
            disabled: itemDisabled,
            ...(status && { status }),
        };

        return stepItem;
    });

    const handleStepClick = (stepIndex: number) => {
        const step = steps[stepIndex];

        if (step.reachable && !isSubmitting) {
            jump(stepIndex);
        }
    };

    return (
        <nav className={className}>
            <Steps current={currentStepIndex} direction="vertical" items={antStepsItems} onChange={handleStepClick} />
        </nav>
    );
}

export default MutltistepFormNavigation;
